export default {
  layout: (state) => state.layout,
};
